export default __webpack_public_path__ + "static/media/money-back@2x.92a80f7d.png";